export default __webpack_public_path__ + "f53bb05c449b6c0d9d79b99c77260cd3.woff2";